module.exports = __webpack_public_path__ + "static/media/checkbox_v.29e3e9f0.svg";